import _ from 'lodash';
import createJobId from './createJobId';

const createJobIds = async (numIds) =>
  Promise.all(_.times(numIds, createJobId));

export default createJobIds;
